import React from 'react'
import { CGE } from '..'
import classNames from 'classnames'

function PanelTitle({ title }) {

  return (
    <div className="cge-panel-title">
      <CGE.Heading text={title} size="3" className="mb-0" />
    </div>
  )

}

function PanelDescription({ description }) {

  return (
    <div  className="cge-panel-description">
      <CGE.Text text={description} size="1" className="mb-0" />
    </div>
  )

}

function PanelSectionTicket({title, children }){

  return (
    <div className="cge-panel-section-ticket">
      {title && 
        <a className="mb-0 cge-panel-section-ticket__title">{title}</a>
      }
      {children}
    </div>
  )
}

function PanelSection({ title, size, children, alingItensCenter }) {

  return (
    <div className="cge-panel-section">
      {title && <div className="cge-panel-section__title">
        <CGE.Heading text={title} size="4" className="color-orange mb-0" />
      </div>}
      <div 
      className={classNames(
        "cge-panel-section__content",
        {
          'cge-panel-section__content--md': size === "md",
          'cge-panel-section__content--sm': size === "sm",
          'cge-panel-section__content--alingItens': alingItensCenter,
        }
      )}>
        {children}
      </div>
    </div>
  )
}

function PanelContainer({  size, children, alingItensCenter, className }) {

  return (
    <div
      className={classNames(
        className,
        "cge-panel-container",
        {
          'cge-panel-container--lg': size === "lg",
          'cge-panel-container--md': size === "md",
          'cge-panel-container--sm': size === "sm",
          'cge-panel-container__alingItens': alingItensCenter,
        }
      )}>
        {children}
      </div>
  )
}

function Panel({ title, description, children, topContent, footerContent, size }) {
  return (
    <div className="cge-panel">

      <div className="cge-panel__header">
        <div className="cge-panel__header__main">
          {title && (
            <div className="cge-panel__header__main__title">
              <PanelTitle title={title} />
            </div>
          )}
          {description && (
            <div className="cge-panel__header__main__description">
              <PanelDescription description={description} />
            </div>
          )}
        </div>

        {topContent && (
          <div className="cge-panel__header__top-content">
            {topContent}
          </div>
        )}

      </div>          
      
      <div
       className={classNames(
        "cge-panel__body",
        {
          'cge-panel__body--md': size === "md",
          'cge-panel__body--sm': size === "sm",
        }
      )}
      >
        {children}
      </div>
          
      {footerContent && (
        <div className="cge-panel__footer"> 
          <div className="cge-panel__footer__footer-content">
            {footerContent}
          </div>
        </div>

        )}

    </div>
  )
}

export { Panel as default, PanelSection, PanelTitle, PanelContainer, PanelSectionTicket }	